/**
 * normalizeNotificationMessage — Cluster D-notifications (Finding 6, Guard C)
 *
 * Persistierte Notification-Bodies stammen teils aus FCM/Telegram-Texten mit
 * Einrückungen und Zeilenumbrüchen. Im HTML kollabiert das zu einer unlesbaren
 * Zeile ("11.535 HNT        24h: ..."). Hier wird der Text deterministisch
 * normalisiert: Zeilenumbrüche werden zu sichtbaren Trennern, Mehrfach-
 * Whitespace wird zusammengefasst und der Text auf eine Maximallänge gekürzt.
 */

export const MESSAGE_SEPARATOR = ' · '
export const DEFAULT_MAX_MESSAGE_LENGTH = 160

export function normalizeNotificationMessage(
  message: string | null | undefined,
  maxLength: number = DEFAULT_MAX_MESSAGE_LENGTH,
): string {
  if (!message) return ''

  const normalized = message
    .replace(/\r\n/g, '\n')
    .replace(/[ \t]*\n[\s]*/g, MESSAGE_SEPARATOR)
    .replace(/[ \t]{2,}/g, ' ')
    .trim()
    // Trenner am Anfang/Ende entfernen (z.B. bei Text mit abschließendem \n)
    .replace(/^(?:\s*·\s*)+/, '')
    .replace(/(?:\s*·\s*)+$/, '')

  if (maxLength > 0 && normalized.length > maxLength) {
    return `${normalized.slice(0, maxLength).trimEnd()}…`
  }

  return normalized
}
